<template>
	<md-dialog :md-active="true" style="font-family: 'Montserrat', sans-serif">
		<div class="msg-dialog">
			<div class="header">
				<span>{{ title || $t("title") }}</span>
				<md-button class="md-icon-button" @click="closeModal(undefined)">
					<md-icon>close</md-icon>
				</md-button>
			</div>
			<div class="body">
				{{ content || $t("no-content") }}
				<component :is="component" v-model="value" :placeholder="'value'" />
			</div>
			<div class="footer">
				<div style="margin-left: auto; margin-right: auto">
					<md-button class="cancel" @click="closeModal(undefined)">
						{{ $t("cancel") }}
					</md-button>
					<md-button class="confirm" @click="closeModal(value)">
						{{ $t("confirm") }}
					</md-button>
				</div>
			</div>
		</div>
	</md-dialog>
</template>

<script>
export default {
	name: "input-modal",
	props: ["show", "title", "content", "component", "old"],
	data() {
		return {
			value: this.old
		}
	},
	methods: {
		closeModal: function (value) {
			if (value != undefined || value != "") this.$emit("close", value)
			else this.$emit("close")
		}
	}
}
</script>

<style lang="scss" scoped>
.msg-dialog {
	max-width: 500px;
	width: 500px;
	padding: 5px;
}
.header {
	width: 100%;
	display: flex;
	padding-left: 10px;
	padding-right: 10px;
	font-weight: 900;
	span {
		margin-top: auto;
		margin-bottom: auto;
	}
	.md-button {
		margin-left: auto;
		margin-right: -10px;
	}
}
.body {
	padding: 10px;
	width: 100%;
}
.footer {
	width: 100%;
	display: flex;
	margin-top: 25px;
	.confirm {
		background-color: lightseagreen;
		color: white;
	}
}
</style>
